module.exports = __webpack_public_path__ + "static/media/aam-family.ed392c0e.jpg";